// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__25SuT","info":"PatientInfo_info__3RjP9"};